import {NgModule} from '@angular/core';
import {IonicPageModule} from 'ionic-angular';
import {NewRegistrationStep3Page} from './new-registration-step3';

@NgModule({
  declarations: [
    NewRegistrationStep3Page,
  ],
  imports: [
    IonicPageModule.forChild(NewRegistrationStep3Page),
  ],
  exports: [
    NewRegistrationStep3Page
  ]
})
export class NewRegistrationStep3PageModule {
}



// WEBPACK FOOTER //
// ./src/pages/new-registration-step3/new-registration-step3.module.ts